import { render, staticRenderFns } from "./EventsNav.vue?vue&type=template&id=6a33c98e&scoped=true"
import script from "./EventsNav.vue?vue&type=script&lang=js"
export * from "./EventsNav.vue?vue&type=script&lang=js"
import style0 from "./EventsNav.vue?vue&type=style&index=0&id=6a33c98e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a33c98e",
  null
  
)

export default component.exports